export enum TherapyType { 
    Family = 1,
    Child = 2,
}